import React, {useState} from "react";

import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import {useParams} from "react-router-dom";
import columns from "./PairingReportTableConfig";
import { useTranslation } from 'react-i18next';
const PairingReportPage = (props) => {
    let {id} = useParams();

    const [loader, setLoader] = useState(false);
    const { t } = useTranslation();


    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("pairingReportPage.pairingReport")}>
                <CardTable
                    tittle={t("pairingReportPage.result")}
                    source={"verification/" + id + "/pairing"}
                    columns={columns}
                    width={12}
                    sorting={false}
                    setLoader={setLoader}
                />

            </CustomContainer>

        </>
    );
};


export default PairingReportPage;